module.exports = __webpack_public_path__ + "img/registered-logo.0045d67c.png";